import { tryGet, tryPost } from './index';

export const createCheckout = async () => {
  console.log('Creating Stripe Session');
  const result = await tryPost(`/subscriptions/stripe/session`, {
    callbackUrl: window.location.href
  });
  console.log(result);
  return result.data;
};

export const updateSession = async (sessionId) => {
  console.log('Updating Company Subscription');
  const result = await tryPost(`/subscriptions/stripe/session/${sessionId}`);
  console.log(result);
  return;
}

export const getSubscription = async () => {
  const result = await tryGet(`/subscriptions?returnUrl=${window.location.href}`);
  console.log(result);
  return result.data;
}

export const getStripeProducts = async () => {
  const result = await tryGet('/subscriptions/stripe/products');
  return result.data;
}